import { INSTANCELIST, INSTANCE } from './API.js'

export const getProductFabrics = () =>
  new Promise((resolve, reject) => {
    INSTANCELIST({
      method: 'get',
      url: `/product-fabrics`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const getProductFabric = (type) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'get',
      url: `/product-fabrics/${type}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const updateProductFabric = (storeId, form) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'put',
      url: `/product-fabrics/store/${storeId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject)
  })
